export default __webpack_public_path__ + "static/flustered-d70d74401f7b0c3c473f1d4bddd0307a.svg";